import { ServiceCollectionBuilder } from "./ServiceCollectionBuilder";
/**
 * Implementation of [[IServiceProvider]] and [[IServiceScope]] that accepts [[ConfigureServices]] as the single required constructor argument.
 */
var ServiceProvider = /** @class */ (function () {
    function ServiceProvider(configureServices, singletonStore, scopeStore) {
        var builder = new ServiceCollectionBuilder(this);
        this._services = configureServices(builder);
        this.singletonStore = singletonStore || new Map();
        this.scopeStore = scopeStore || new Map();
        this.configureServices = configureServices;
    }
    /**
     * Returns the typesafe service collection of [[ServiceResolver]]s for your services.
     */
    ServiceProvider.prototype.services = function () {
        return this._services;
    };
    /**
     * Create a new scope.  Scoped services are not linked to the parent scope, and are stored only for the lifetime of the scope.
     */
    ServiceProvider.prototype.createScope = function () {
        // Create a new provider that contains a new scope.
        return new ServiceProvider(this.configureServices, this.singletonStore, new Map());
    };
    /**
     * Returns a singleton service either from the store or by calling the factory.
     *
     * This method is not normally used directly, you should normally use services() instead.
     * @param factory
     */
    ServiceProvider.prototype.getSingleton = function (factory) {
        if (this.singletonStore.has(factory)) {
            return this.singletonStore.get(factory);
        }
        var ret = factory(this.services());
        this.singletonStore.set(factory, ret);
        return ret;
    };
    /**
     * Returns a scoped service either from the store or by calling the factory.
     *
     * This method is not normally used directly, you should normally use services() instead.
     * @param factory
     */
    ServiceProvider.prototype.getScoped = function (factory) {
        if (this.scopeStore.has(factory)) {
            return this.scopeStore.get(factory);
        }
        var ret = factory(this.services());
        this.scopeStore.set(factory, ret);
        return ret;
    };
    /**
     * Returns a transiant service by calling the factory.
     *
     * This method is not normally used directly, you should normally use services() instead.
     * @param factory
     */
    ServiceProvider.prototype.getTransiant = function (factory) {
        return factory(this.services());
    };
    return ServiceProvider;
}());
export { ServiceProvider };
//# sourceMappingURL=ServiceProvider.js.map